import { Component } from '@angular/core';

import { of } from 'rxjs';

import {
  CamNotificationDataService,
  InvoicePaymentStatusChangedComponent,
  MailSendFailedComponent,
  NewInvoiceComponent,
  NewQuotationVersionComponent,
  ProjectStatusChangedComponent,
  TaskAssignedComponent,
  TaskDueTodayComponent,
  TaskNewActivityComponent,
  ToDoAssignedComponent,
  ToDoDueTodayComponent,
  UserTaggedInConversationComponent,
} from '@camelot/notification';

import { TestIdDirective } from '@camelot/testing-harness';
import { notificationMock } from './notification.case';

const dataServiceMock = {
  computeKey: () => 'all',
  count: { get$: () => of(0) },
  fetchNotifications$: () => of([]),
  fetchNumberOfNotifications$: () => of(0),
  isRead$: () => of(true),
  list: { get$: () => of([]) },
  markAsRead$: () => of(true),
};

@Component({
    imports: [
        InvoicePaymentStatusChangedComponent,
        MailSendFailedComponent,
        NewInvoiceComponent,
        NewQuotationVersionComponent,
        ProjectStatusChangedComponent,
        TaskAssignedComponent,
        TaskDueTodayComponent,
        TaskNewActivityComponent,
        TestIdDirective,
        ToDoAssignedComponent,
        ToDoDueTodayComponent,
        UserTaggedInConversationComponent,
    ],
    providers: [{ provide: CamNotificationDataService, useValue: dataServiceMock }],
    template: `
    <cam-invoice-payment-status-changed
      camTestId="cam-invoice-payment-status-changed"
      [notification]="this.notification"
    />
    <cam-new-invoice camTestId="cam-new-invoice" [notification]="this.notification" />
    <cam-new-quotation-version camTestId="cam-new-quotation-version" [notification]="this.notification" />
    <cam-notification-project-status-changed
      camTestId="cam-notification-project-status-changed"
      [notification]="this.notification"
    />
    <cam-task-assigned camTestId="cam-task-assigned" [notification]="this.notification" />
    <cam-task-due-today camTestId="cam-task-due-today" [notification]="this.notification" />
    <cam-task-new-activity camTestId="cam-task-new-activity" [notification]="this.notification" />
    <cam-to-do-assigned camTestId="cam-to-do-assigned" [notification]="this.notification" />
    <cam-to-do-due-today camTestId="cam-to-do-due-today" [notification]="this.notification" />
    <cam-user-tagged-in-conversation
      camTestId="cam-user-tagged-in-conversation"
      [notification]="this.notification"
    />
    <cam-mail-send-failed camTestId="cam-mail-send-failed" [notification]="this.notification" />
  `
})
export class NotificationTemplatesCase {
  public notification = notificationMock;
}
